import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { OverlaySideFormService } from '../../shared/overlay-side-form/overlay-side-form.service';
import { alert } from "devextreme/ui/dialog";

@Component({
  selector: 'app-webcamnica',
  templateUrl: './webcamnica.component.html',
  styleUrls: ['./webcamnica.component.css']
})
export class WebcamnicaComponent implements OnInit, AfterViewInit, OnDestroy {
  
  @Input() configuration: any;
  @Input() autoPlay: true;
  @Input() itemData: any;
  @Output() emitFoto: EventEmitter<any> = new EventEmitter<any>(); 
  @Output() emitData: EventEmitter<any> = new EventEmitter<any>(); 
  
  video: HTMLVideoElement;
  canvas: HTMLCanvasElement;
  photo: HTMLImageElement;
  mediaStream: MediaStream | null = null; // Aggiungi il riferimento al mediaStream
  isAcquisita: boolean = false;

  constructor(private overlay: OverlaySideFormService) { }

  ngAfterViewInit(): void {
    const constraints = { audio: false, video: { width: 200, height: 200 } }; 
    
    navigator.mediaDevices.getUserMedia(constraints)
      .then((mediaStream) => {               
        this.mediaStream = mediaStream; // Salva il riferimento al mediaStream
        this.video = document.getElementById('video') as HTMLVideoElement; 
        this.video.srcObject = mediaStream;
        this.video.play();       
      })
      .catch((err) => {
        console.log(err.name + ": " + err.message);
      });
      
    this.video = document.getElementById('video') as HTMLVideoElement;
    this.canvas = document.getElementById('canvas') as HTMLCanvasElement;
    this.photo = document.getElementById('photo') as HTMLImageElement;
  }

  ngOnInit() {
    if (this.itemData && this.itemData.idUser) {
      // Logica per l'inizializzazione
    }
  }

  Acquisisci() {
    if (!this.isAcquisita) {
      alert("Devi prima scattare la foto", 'Acquisizione Immagine');
      return;
    }

    const width = this.video.videoWidth;
    const height = this.video.videoHeight;

    this.canvas.width = width;
    this.canvas.height = height;

    const context = this.canvas.getContext('2d');
    context.drawImage(this.video, 0, 0, width, height);

    const data = this.canvas.toDataURL('image/png');
    this.emitFoto.next(data);
    this.emitData.emit(data);

    // Chiudi la webcam e ferma lo stream
    this.fermaStream();
    this.overlay.close(); // Chiude il pop-up
  }

  Scatta() {
    const width = this.video.videoWidth;
    const height = this.video.videoHeight;

    this.canvas.width = width;
    this.canvas.height = height;

    const context = this.canvas.getContext('2d');
    context.drawImage(this.video, 0, 0, width, height);
    
    const data = this.canvas.toDataURL('image/png');
    this.photo.setAttribute('src', data);
    this.isAcquisita = true;
  }

  clearphoto() {
    this.isAcquisita = false;
    const context = this.canvas.getContext('2d');
    context.fillStyle = "#AAA";
    context.fillRect(0, 0, this.canvas.width, this.canvas.height);
    this.photo.setAttribute('src', this.canvas.toDataURL('image/png'));
  }

  // Metodo per fermare il flusso multimediale
  fermaStream() {
    if (this.mediaStream) {
      const tracks = this.mediaStream.getTracks();
      tracks.forEach(track => track.stop()); // Ferma ogni traccia dello stream
      this.mediaStream = null;
    }
  }

  ngOnDestroy() {
    // Ferma il flusso quando il componente viene distrutto
    this.fermaStream();
  }

  OpenCam() {
    this.video.play();
  }
}
